import * as React from "react";
import ReactDOM from "react-dom";

import { useColorMode, WithThemeContext } from "./theme";
import * as ServiceWorker from "./serviceWorker";
import App from "./Application";
import CssBaseline from "@mui/material/CssBaseline";
import { FiltersContext } from "./context/filters";
import { SettingsContext } from "./context/settings";
import Privacy from "./Privacy";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import { StatusBar, Style } from "@capacitor/status-bar";
import { Box } from "@mui/material";
import { SplashScreen } from "@capacitor/splash-screen";

const defaultFilters = {
  "ru-be": true,
  "be-ru": true,
  "en-be": true,
  tsbm: true,
  grammer: true,
  phonetic: true,
};

const defaultSettings = {
  keyboardHelpers: true,
  autoSearch: true,
  language: "be",
  showDetails: true,
};

function Application() {
  const { mode } = useColorMode();
  const naviteApp = Capacitor.isNativePlatform();

  if (naviteApp) {
    StatusBar.setOverlaysWebView({ overlay: true });
    SplashScreen.hide();
  }

  const setStatusBarStyleDark = async () => {
    await StatusBar.setStyle({ style: Style.Dark });
  };

  const setStatusBarStyleLight = async () => {
    await StatusBar.setStyle({ style: Style.Light });
  };

  const [settings, setSettings] = React.useState(
    JSON.parse(
      localStorage.getItem("settings") || JSON.stringify(defaultSettings)
    )
  );

  const [filters, setFilters] = React.useState(
    JSON.parse(
      localStorage.getItem("filters") || JSON.stringify(defaultFilters)
    )
  );

  React.useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      mode === "dark" ? setStatusBarStyleDark() : setStatusBarStyleLight();
    }
  }, [mode]);

  React.useEffect(() => {
    const splash = document.getElementById("splash");
    if (splash) {
      splash.classList.add("hidden");
      setTimeout(() => {
        splash.remove();
      }, 1000);
    }
  }, []);

  return (
    <SettingsContext.Provider
      value={{
        ...settings,
        change: (nextState) => {
          setSettings(nextState);
        },
      }}
    >
      <FiltersContext.Provider
        value={{
          ...filters,
          change: (nextState) => {
            setFilters(nextState);
          },
        }}
      >
        <CssBaseline />
        <Box
          style={
            naviteApp
              ? {
                  position: "absolute",
                  top: 24,
                  bottom: 0,
                  left: 0,
                  right: 0,
                }
              : {}
          }
        >
          <Routes>
            <Route path="/" element={<App />} />
            <Route path="privacy" element={<Privacy />} />
          </Routes>
        </Box>
      </FiltersContext.Provider>
    </SettingsContext.Provider>
  );
}

ReactDOM.render(
  <BrowserRouter>
    <WithThemeContext>
      <Application />
    </WithThemeContext>
  </BrowserRouter>,
  document.querySelector("#root")
);

ServiceWorker.register();
